import React from 'react';

import {Button, Modal, Typography} from 'antd';

/**
 * User table component which shows all users data
 */
class MessageModal extends React.Component {

  closeModal = () => {
    this.setState({showModal: false});
  };

  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      message: '',
      title: '',
      showOkButton: false,
      showCancelButton: false,
      handleOk: null,
      handleCancel: null,
      okText: 'OK',
      cancelText: 'Cancel'
    }
  }

  componentDidLoad() {
  }

  render() {
    let footerButtons = [];

    if (this.state.showCancelButton) {
      footerButtons.push(
        <Button block key="cancel" type="primary" ghost onClick={() => {
          this.setState({showModal: false}, () => {
            if(this.state.handleCancel !== null)
              this.state.handleCancel();
          });
        }}>
          {this.state.cancelText}
        </Button>);
    }

    if (this.state.showOkButton) {
      footerButtons.push(
        <Button block key="submit" type="primary" onClick={() => {
          this.setState({showModal: false}, () => {
            if(this.state.handleOk !== null)
              this.state.handleOk();
          });
        }}>
          {this.state.okText}
        </Button>);
    }

    return (
      (<Modal
        centered={true}
        confirmLoading={false}
        open={this.state.showModal}
        title={<Typography.Title level={3} style={{ margin: 0 }}>{this.state.title}</Typography.Title>}
        closable={false}
        footer={footerButtons}
      >
        <div>{this.state.message}</div>
      </Modal>)
    );
  }

}

export default MessageModal;